import * as React from 'react';
import * as Redux from 'redux';
import { connect } from 'react-redux';
import DefaultButton from './../../../components/DefaultButton';
import IconEdit from './../../../icons/edit.svg';
import IconDelete from './../../../icons/delete.svg';
import ReactSVG from 'react-svg';
import { modalInstance } from './../Content';
import styled from 'styled-components';
import { renderAttributeInfo } from './../../../utilities/renderAttributes.jsx';
import { fieldsDictionary } from './../../../utilities/flightDictionaries';
import { translate } from "react-i18next";
import {
    deleteFlight,
    editFlight,
} from './../../../actions/flightManager';
import {
    centerMap, setEditMode
} from './../../../actions/map';

const ButtonWrapper = styled.div`
    position: absolute;
    right: 5px;
    top: -2px;
    display: flex;
    justify-content: flex-start;
`;

const FlexWrapper = styled.div`
    overflow-y: auto;
    max-height: ${props => props.visible ? '550px' : '0px'};
    transition: max-height 0.5s;
    padding: 0 10px;
    white-space: pre-wrap;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    border-bottom: ${props => props.visible
        ? '1.5px solid rgba(128,128,128,0.1);'
        : '0px'
    };
`;

const AttributeRow = styled.tr`
    width:100%;
    font-size: 15px;
    font-weight: lighter;
    min-height: 18px;
    margin-bottom: 2px;
    div:last-child {
        margin-bottom: 5px;
    }
    input, select{
        padding: 2px;
        border: 1px solid grey;
        border-radius: 2px;
    }
    input {
        width: 150px;
    }
    select {
        width: 156px;
    }
    span {
        margin-right: 2px;
    }
`;

const AttributeTable = styled.table`
    table-layout: fixed;
    width: 100%;
`;
const AttributeName = styled.td`
    color:  #2d2d2d;
    font-size: 13px;
    font-weight: 400;
    width: 40%;
`;

const AttributeValue = styled.td`
    color:  #265a9c;
    font-size: 13px;
    font-weight: 700;
    width: 100%;
    overflow: hidden;
    display: inline-block;
    white-space: pre-wrap;
`;

const Description = styled.p`
    color:  #265a9c;
    font-size: 13px;
    font-weight: 700;
    font-weight: bold;
    margin: 5px 0;
    display: ${props => props.visible === false ? 'none' : 'block'};
`;

class AttributesContainer extends React.Component {
    constructor() {
        super();
        this.state = {
            editedFeature: { id: 0 },
            modalVisible: false,
        }
    };

    renderAttributes = () => {
        const { flight, products, t } = this.props;
        const attributes = Object.keys(flight).filter(attribute => {
            const excludedAttributes = [
                'geomWkt', 'id'
            ]
            return !excludedAttributes.includes(attribute);
        });

        return attributes
            .filter(attribute => fieldsDictionary[attribute] && fieldsDictionary[attribute].visible)
            .map(attribute => {
                return (
                    <AttributeRow key={attribute}>
                        <AttributeName>
                            {`${t(fieldsDictionary[attribute].header)}: `}
                        </AttributeName>
                        <AttributeValue>
                            {renderAttributeInfo(fieldsDictionary[attribute], flight[attribute], t, products)}
                        </AttributeValue>
                    </AttributeRow>
                )
            })
    };

    customizeModalWindow(flight) {
        const { axiosInstance, deleteFlight, t } = this.props
        const confirmCallback = () => {
            deleteFlight(axiosInstance, flight.id)
        }
        const config = {
            title: t('Do you really want to delete mission') + '?',
            content: <p>{t('Do you really want to delete mission')} <b>{String(flight.projectName)}</b>?</p>,
            confirmCallback: confirmCallback,
            confirmBtnVisible: true,
            cancelBtnVisible: true,
            confirmBtnText: t('Delete'),
            closeOnConfirm: true,
            type: 'warning',
        };
        modalInstance.customize(config);
    }

    render() {
        const {
            flight,
            visible,
            roles,
            t,
        } = this.props;
        return (
            <FlexWrapper
                onClick={(e) => { e.preventDefault() }}
                visible={visible}>
                <ButtonWrapper>
                    <DefaultButton
                        visible={visible}
                        style={{
                            position: 'absolute',
                            right: '33px',
                            top: '8px',
                        }}
                        title={t('Edit')}
                        disabled={roles === 'Regular'}
                        onClick={(e) => {
                            this.props.setEditMode(true);
                            this.props.openSelf();
                        }}>
                        <ReactSVG
                            path={IconEdit}
                            style={{
                                padding: '2px',
                                fill: '#ffffff',
                                width: '20px',
                                height: '20px'
                            }}
                        />
                    </DefaultButton>
                    <DefaultButton
                        type='warning'
                        visible={visible}
                        style={{
                            position: 'absolute',
                            right: '2px',
                            top: '8px',
                        }}
                        title={t('Delete')}
                        disabled={roles === 'Regular'}
                        onClick={(e) => {
                            this.customizeModalWindow(flight);
                            modalInstance.show();
                        }}>
                        <ReactSVG
                            path={IconDelete}
                            style={{
                                padding: '2px',
                                fill: '#ffffff',
                                width: '20px',
                                height: '20px',
                            }}
                        />
                    </DefaultButton>
                </ButtonWrapper>
                <Description>
                    {t('About mission')}:
                </Description>
                <AttributeTable>
                    <tbody>
                        {this.renderAttributes()}
                    </tbody>
                </AttributeTable>
            </FlexWrapper >
        );
    }
};

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
    products: state.flightManager.get('products'),
    olMap: state.mapData.get('olMap'),
    roles: state.auth.get('roles'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    deleteFlight,
    editFlight,
    centerMap,
    setEditMode,
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(AttributesContainer));


// WEBPACK FOOTER //
// ./src/containers/content/flightManager/AttributesContainer.jsx